export const generateRandomColors = () => {
  // Professional blue-cyan-navy blue-teal gradient
  return 'linear-gradient(135deg, #2196F3 0%, #00BCD4 25%, #1A237E 75%, #009688 100%)';
};
